import './App.scss';
import HomePage from './home_page/home_page';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
